import { Dialog, DialogContent, DialogTitle, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { RatelistType } from "@sinch/core/entities/serverEnums";
import { useOpenState } from "@sinch/hooks/utilities/useOpenState";
import { MdsHistory } from "@sinch/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { Revisions } from "@sinch/components/application/Rate/Revisions/Revision";
import { useRatelistType } from "@sinch/components/application/Rate/useRatelistType";
import { DialogCloseIcon } from "@sinch/components/DialogCloseIcon/DialogCloseIcon";

export function RevisionDialog(props: {
  onClose: () => void;
  open: boolean;
  ratelistId: string | null;
  type: RatelistType;
}) {
  const { t } = useTranslation(["common", "draft"]);
  const { getRatelistTypeEditUri } = useRatelistType();

  if (!props.ratelistId) {
    return null;
  }
  return (
    <Dialog onClose={props.onClose} open={props.open}>
      <DialogTitle sx={{ minHeight: "80px" }}>
        {t("revisions")}
        <DialogCloseIcon onClick={props.onClose} />
      </DialogTitle>
      <DialogContent>
        <Revisions
          onClickDetail={(id) => {
            globalThis.location.href = getRatelistTypeEditUri(props.type)(id);
            close();
          }}
          ratelistId={props.ratelistId}
        />
      </DialogContent>
    </Dialog>
  );
}

export const RevisionsMenuItem = ({ id, type }: { id: string; type: RatelistType }) => {
  const { t } = useTranslation(["common", "draft"]);

  const [openRevisions, open, close] = useOpenState();

  return (
    <>
      <MenuItem onClick={open}>
        <ListItemIcon>
          <MdsIcon icon={MdsHistory} />
        </ListItemIcon>
        <ListItemText>{t("revisions")}</ListItemText>
      </MenuItem>
      <RevisionDialog onClose={close} open={openRevisions} ratelistId={id} type={type} />
    </>
  );
};
